import bw from 'binary-wheel'
import proto from '../proto.bw.coffee'
import noise from './noise.coffee'
import { fitString, httpGet } from './tools.coffee'
import { maxCoord, coord, angle } from './game.coffee'
import { gl, MeshSet, Program, Texture } from './gl.coffee'

spriteRect = (r, sx, sy = sx) ->
	x0: Math.trunc r[0]*0xffff/sx
	y0: Math.trunc r[1]*0xffff/sy
	x1: Math.trunc (r[0] + r[2])*0xffff/sx
	y1: Math.trunc (r[1] + r[3])*0xffff/sy
	aspX: r[2]/r[3]
	aspY: r[3]/r[2]

spriteRects = require '!inkscape-sprite-rects-loader!./assets/sprites.svg'
spriteRects[name] = spriteRect r, 1024 for name, r of spriteRects

export colors =
	engine: 0x05050510
	cabin: 0x0f0f0fff
	Missile: 0x1a80e6ff
	Asteroid: 0x4d4d4dff
	WarpEnter: 0x801ae6
	WarpExit: 0x1a80e6
	bonus: [0xff3333ff, 0x3380ffff]
	graph: { r: 0xff0000cc, g: 0x00ff00cc, b: 0x0000ffcc }
	hull: [
		[0xb90f0fff, 0xffa500ff, 0xfafa3cff, 0x69cd2dff, 0x3ca0faff, 0xcd00cdff, 0xd7d7e6ff]
		[0x3c0c0cff, 0x552300ff, 0x504416ff, 0x003c15ff, 0x1e286eff, 0x441650ff, 0x282832ff]]
	team: [
		0x33c120, 0x207dc1, 0xc12020, 0xdddd39, 0x38dadd, 0xedbe34, 0xb729c4, 0x610cd1, 0xd10b61, 0x8dfc9a]
	skill:
		Blaster:		0xe61a00ff
		Flak:			0xe6801aff
		Missiles:		0x1a80e6ff
		Ray:			0x8000b3ff
		BombGun:		0xe6331aff
		Boost:			0xff801aff
		Shield:			0x1a80ccff
		Force:			0x1a80ccff
		BlackHoleGun:	0x991accff
		WarpGun:		0x991accff
		HookGun:		0x1a80ccff
	radar:
		Enemy: 0xff0000
		Friend: 0x20f020
		Leader: 0xffaa00
		Revenge: 0xff0000

playerView = {x: 1200, y: 800}

skills =
	Blaster:
		slot: 0
	Flak:
		slot: 0
	Missiles:
		slot: 0
		targets: {Ship: true, Asteroid: true}
	Ray:
		slot: 0
	BombGun:
		slot: 0
	Boost:
		slot: 1
	Shield:
		slot: 1
	Force:
		slot: 1
		hold: true
		targets: {Asteroid: true}
		cancel: (view, target) -> target and 64*64 > Math.len2 coord(view.originX + view.controls.x - target.cx), coord(view.originY + view.controls.y - target.cy)
	BlackHoleGun:
		slot: 1
		hold: true
	WarpGun:
		slot: 1
		hold: true
		cancel: (view, target) -> 64*64 > Math.len2 view.controls.x - 200*Math.cos(target.ca), view.controls.y - 200*Math.sin(target.ca)
	HookGun:
		slot: 1

colora = (c, a) -> c << 8 | Math.round a*255

eyeZ = 1800

class Sprites
	constructor: (n) ->
		@n = 0
		@data = new ArrayBuffer n*16*6
		@f32 = new Float32Array @data
		@u16 = new Uint16Array @data
		@view = new DataView @data

	addVert: (x, y, tx, ty, c) ->
		i = @n
		@f32[i] = x; i += 1
		@f32[i] = y; i += 1
		@u16[i*2    ] = tx
		@u16[i*2 + 1] = ty
		i += 1
		@view.setUint32 i*4, c; i += 1
		@n = i

	addRect: (x0, y0, x1, y1, tx0, ty0, tx1, ty1, c = 0xffffffff) ->
		@addVert x0, y0, tx0, ty0, c
		@addVert x1, y0, tx1, ty0, c
		@addVert x1, y1, tx1, ty1, c
		@addVert x0, y0, tx0, ty0, c
		@addVert x1, y1, tx1, ty1, c
		@addVert x0, y1, tx0, ty1, c
		return

	add: (x,y, sx, sy, st, c = 0xffffffff) ->
		sx ?= sy*st.aspX
		sy ?= sx*st.aspY
		@addRect x - sx, y - sy, x + sx, y + sy, st.x0, st.y0, st.x1, st.y1, c

	line: (x, y, dx, dy, step, r, st, c) ->
		l = Math.sqrt dx*dx + dy*dy
		n = Math.trunc l/step
		dx *= step/l
		dy *= step/l
		while n--
			@add x,y, r,r, st, c
			x += dx
			y += dy

	addDirLine: (ang, l,w, st, c = 0xffffffff) ->
		x = l*Math.cos ang
		y = l*Math.sin ang
		@addPart x,y, l,w, st, 1,1, ang, x,y, c

	addName: (x,y, sx = sy*st.aspX, sy = sx*st.aspY, st, c = 0xffffffff) ->
		sx ?= sy*st.aspX
		sy ?= sx*st.aspY
		@addRect x, y, x + sx, y + sy, st.x0, st.y0, st.x1, st.y1, c
		sx

	@numberWidth: (v, nd) ->
		w = 0
		for d in v.toString()
			w += spriteRects[d].aspX
		w

	addNumberRight: (x,y, sy, v, c) ->
		for d in v.toString() by -1
			st = spriteRects[d]
			sx = sy*st.aspX
			x -= sx*0.8
			@addRect x, y, x + sx, y + sy, st.x0, st.y0, st.x1, st.y1, c

	addNumberLeft: (x,y, sy, v, c) -> @addNumberRight x + Sprites.numberWidth(v)*sy*0.8, y, sy, v, c
	addNumberCenter: (x,y, sy, v, c) -> @addNumberRight x + Sprites.numberWidth(v)*sy*0.5*0.8 - sy*0.05, y - sy*0.5, sy, v, c

	addPart: (x,y, sx, sy, st, fx = 1, fy = 1, ang = 0, cx = 0, cy = 0, color = 0xffffffff) ->
		sx ?= sy*st.aspX
		sy ?= sx*st.aspY
		thw = (st.x1 - st.x0)*0.5
		thh = (st.y1 - st.y0)*0.5
		tx = st.x0 + thw
		ty = st.y0 + thh
		thw *= fx
		thh *= fy
		sx *= fx
		sy *= fy
		c = Math.cos ang
		s = Math.sin ang
		tx0 = tx - thw; ty0 = ty - thh
		tx1 = tx + thw; ty1 = ty + thh
		rx0 = x - cx - sx; ry0 = y - cy - sy
		rx1 = x - cx + sx; ry1 = y - cy + sy
		x0 = cx + rx0*c - ry0*s; y0 = cy + rx0*s + ry0*c
		x1 = cx + rx1*c - ry0*s; y1 = cy + rx1*s + ry0*c
		x2 = cx + rx0*c - ry1*s; y2 = cy + rx0*s + ry1*c
		x3 = cx + rx1*c - ry1*s; y3 = cy + rx1*s + ry1*c
		@addVert x0, y0, tx0, ty0, color
		@addVert x1, y1, tx1, ty0, color
		@addVert x3, y3, tx1, ty1, color
		@addVert x0, y0, tx0, ty0, color
		@addVert x3, y3, tx1, ty1, color
		@addVert x2, y2, tx0, ty1, color
		return

	addHorBar: (x,y, sx,sy, st, v, c = 0xffffffff) ->
		sx or= 2*sy*st.aspX
		sy or= 0.5*sx*st.aspY
		tx = v * (st.x1 - st.x0)
		hy = (st.y0 + st.y1)*0.5
		@addRect x - sx, y - sy, x + sx, y + sy, st.x0, st.y0, st.x1, hy, c
		@addRect x - sx, y - sy, x + sx*(v*2 - 1), y + sy, st.x0, hy, st.x0 + tx, st.y1, c

	addBar: (x,y, sx,sy, st, v, c = 0xffffffff) ->
		sx or= 0.5*sy*st.aspX
		sy or= 2*sx*st.aspY
		py = v * sy * 2
		ty = v * (st.y1 - st.y0)
		hx = (st.x0 + st.x1)*0.5
		@addRect x - sx, y - sy, x + sx, y + sy, st.x0, st.y0, hx, st.y1, c
		@addRect x - sx, y - sy + py, x + sx, y + sy, hx, st.y0 + ty, st.x1, st.y1, c

	draw: -> if @n
		gl.bufferData gl.ARRAY_BUFFER, @f32.subarray(0, @n), gl.DYNAMIC_DRAW
		gl.drawArrays gl.TRIANGLES, 0, @n/4
		@n = 0

export programs = {}
export textures = {}
export buffers = {}

loadMeshes = (name, onload) ->
	httpGet name, 'arraybuffer', (response) ->
		b = new bw.Reader response
		parts = for i in [0...b.u32()]
			first: b.u32()
			count: b.u32()
			points: for j in [0...b.u32()]
				[b.f32(), b.f32(), b.f32(), b.f32()]
		vertsCount = b.u32()
		indicesCount = b.u32()
		verts = b.buf vertsCount*18
		indices = b.buf indicesCount*2
		buffer = buffers[name] = new MeshSet [{count: 3, type: gl.SHORT, norm: true}, {count: 3, type: gl.SHORT, norm: true}, {count: 3, type: gl.UNSIGNED_SHORT, norm: true}], verts, indices, parts
		onload? buffer

export init = (onload) ->
	gl.disable gl.DEPTH_TEST
	gl.disable gl.BLEND
	gl.depthMask true
	Texture.firstFreeSlot = 0
	gl.clearColor 0, 0, 0, 0
	gl.clear gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER_BIT
	loadingCount = 0
	finishLoading = ->
		loadingCount -= 1
		onload?() if loadingCount == 0
	programs.mesh = new Program require './shaders/mesh.glsl'
	programs.sprite = new Program require './shaders/sprite.glsl'
	programs.space = new Program require './shaders/space.glsl'
	programs.blackHole = new Program require './shaders/blackhole.glsl'
	programs.rock = new Program require './shaders/rock.glsl'
	loadingCount += 1
	loadMeshes require('./assets/spaceships.blend'), -> finishLoading()
	buffers.rect = new MeshSet [{count: 2}], new Float32Array [-1,-1, -1,1, 1,1, -1,-1, 1,1, 1,-1]
	buffers.sprite = new MeshSet [{count: 2}, {count: 2, type: gl.UNSIGNED_SHORT, norm: true}, {count: 4, type: gl.UNSIGNED_BYTE, norm: true}]
	buffers.rocks = MeshSet.compose [
		Math.icoSphere(1).calculateNormals()
		Math.icoSphere(3).deform((v) -> Math.scale3(v, 0.75 + 0.25*noise.perlin3(v[0], v[1], v[2]))).calculateNormals()]
	textures.shipColors = new Texture
		width: 4, height: 8*8
		filter: gl.NEAREST
		data: do ->
			data = new ArrayBuffer 4*4*8*8
			v = new DataView data
			for c0, i in colors.hull[0]
				for c1, j in colors.hull[1]
					r = (i*8 + j)*16
					v.setUint32 r     , colors.cabin
					v.setUint32 r +  4, c0
					v.setUint32 r +  8, c1
					v.setUint32 r + 12, colors.engine
			new Uint8Array data
	textures.shipColors.lockTextureSlot()
	textures.space = new Texture {width: 1024, height: 1024, wrap: gl.REPEAT}, -> programs.space.draw buffers.rect
	textures.space.lockTextureSlot()
	textures.players = new Texture
		minFilter: gl.LINEAR_MIPMAP_NEAREST
	programs.parallax = new Program require('./shaders/parallax.glsl'),
		space: textures.space
	loadingCount += 1
	textures.sref = Texture.load require('./assets/sref.png'), {}, (texture) ->
		texture.lockTextureSlot()
		programs.mesh.use
			tex: textures.shipColors
			ref: texture
		finishLoading()
	loadingCount += 1
	textures.sprites = Texture.load require('./assets/sprites.svg'), {}, (texture) ->
		texture.drawTo ->
			gl.viewport 512, 0, 512, 512
			programs.blackHole.draw buffers.rect
		texture.lockTextureSlot()
		finishLoading()

export drawShipModel = (type, c0, c1) ->
	gl.enable gl.DEPTH_TEST
	programs.mesh.use
		proj: Math.frustum 1, 1, 1, 101
		view: [-1,0,0,0, 0,1,0,0, 0,0,1,0, 0,-0.1,-2,1]
		type: (c0*8 + c1)/64
	buffers.spaceships.use programs.mesh.attribs
	buffers.spaceships.drawPart type
	gl.disable gl.DEPTH_TEST

export class View
	constructor: (@stats) ->
		@sprites = new Sprites 16768
		@xsprites = new Sprites 1024
		@zsprites = new Sprites 1024
		@nameSprites = new Sprites 256
		@particles = []
		@originX = @originY = 0
		@controls = {x: 0, y: 0, weaponState: [{}, {}]}
		@showUI = true
		@showFPS = false
		@prevTime = @curTime = Date.now()

	explode: (e) ->
		count = 1 + Math.round Math.sqrt e.power
		while count--
			a = Math.random()*Math.PI*2
			r = Math.random()*e.power
			c = colors[e.type] or colors.skill.Flak
			@particles.push
				time: e.time
				lifetime: 500
				size0: 0.35*e.power
				size1: 1.5*e.power
				color: c >> 8
				x: e.x
				y: e.y
				dx: r*Math.cos a
				dy: r*Math.sin a

	trail: (x0, y0, t0, x1, y1, t1, lifetime, size0, size1, color, sprite, sprites) ->
		l = Math.len coord(x0 - x1), coord(y0 - y1)
		x = 0
		t = 0
		step = 0.25*(size0 + size1)
		dt = step/l
		while x < l
			t += dt
			@particles.push
				time: Math.lerp t0, t1, t
				lifetime: lifetime
				size0: size0
				size1: size1
				color: color >> 8
				x: Math.lerpAngle x0, x1, t, maxCoord
				y: Math.lerpAngle y0, y1, t, maxCoord
				dx: 0
				dy: 0
				sprite: sprite
				sprites: sprites
			x += step

	bodyTrail: (body, lifetime, size0, size1, color, sprite, sprites) ->
		if lifetime and body.tailX?
			@trail body.cx, body.cy, @curTime, body.tailX, body.tailY, @prevTime, lifetime, size0, size1, color, sprite, sprites
		body.tailX = body.cx
		body.tailY = body.cy

	resize: (@w, @h) ->
		@vmin = 0.01*Math.min @w, @h
		@margin = 2.5*@vmin
		@aspX = Math.min 1, (playerView.y*@w)/(playerView.x*@h)
		@aspY = @aspX*@h/@w
		@proj = Math.frustum @aspX, @aspY, 1, 2500
		@viewProj = Math.frustumZ @aspX, @aspY, 1, 2500, eyeZ
		programs.parallax.use {asp: [@aspX*0.8, -@aspY*0.8]}
		programs.mesh.use {proj: @proj}
		programs.rock.use {proj: @proj}
		@updatePlayersTexture @game.players if @game?

	screenToLocalX: (x) -> (x/@w - 0.5)*eyeZ*@aspX
	screenToLocalY: (y) -> (y/@h - 0.5)*eyeZ*@aspY
	localX: (x) -> coord x - @originX
	localY: (y) -> coord y - @originY

	aimAt: (x, y) ->
		@controls.x = @screenToLocalX x
		@controls.y = @screenToLocalY y
		for skill, i in @game.player.skills when not skill.hold
			x = coord @originX + @controls.x
			y = coord @originY + @controls.y
			skill.target = @targetAt x, y, skills[skill.type].targets

	update: ->
		@prevTime = @curTime
		@curTime = Date.now()
		if not @game
			return
		for body in @game.bodies when body
			while body.time < @curTime
				body.x += body.vx
				body.y += body.vy
				body.vx *= body.damping
				body.vy *= body.damping
				body.time += 10
			t = (@curTime - @prevTime)/(body.time - @prevTime)
			body.cx = Math.lerpAngle body.cx, body.x, t, maxCoord
			body.cy = Math.lerpAngle body.cy, body.y, t, maxCoord
			body.ca = Math.lerpAngle body.ca, body.a, t
			if body.type == 'Ship' and body.player == @game.player
				@originX = body.cx
				@originY = body.cy

	targetAt: (x, y, targets) -> if targets
		minDist2 = 128*128
		target = undefined
		for body in @game.bodies when body and body != @game.player.ship and targets[body.type]
			dist2 = Math.len2 coord(body.cx - x), coord(body.cy - y)
			r = Math.max body.radius, 64
			if dist2 < minDist2 and dist2 < r*r
				target = body
				minDist2 = dist2
		target

	resetControls: ->
		for weapon in @controls.weaponState
			weapon.fire = false
			delete weapon.target
		delete @controls.emotion
		@controls.respawn = false

	updateControls: (state) ->
		for skill, i in @game.player.skills
			@controls.weaponState[i].active = state[i] and not skills[skill.type].hold
		for skill, i in @game.player.skills
			target = skill.target ? @game.player.ship
			if skills[skill.type].hold
				if skill.hold and not state[i] and not skills[skill.type].cancel? @, target
					@controls.weaponState[i].fire = true
					@controls.weaponState[i].target = target.id
			else if state[i] and not skill.hold
				@controls.weaponState[i].fire = true
				@controls.weaponState[i].target = target.id
			skill.hold = state[i]
		@controls.emotion ?= (proto.Emotion.members.find (e) => state[e])
		@controls.keepDirection = state.keepDirection
		@controls.inviteToTeam = state.inviteToTeam
		@controls.leaveTeam = state.leaveTeam

	draw: ->
		@update()
		if @game?.playersChanged
			@updatePlayersTexture @game.players
			@game.playersChanged = false
		gl.clear gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT
		gl.disable gl.BLEND
		programs.parallax.draw buffers.rect, pos: [
			@originX/maxCoord*0.5 + 0.5
			@originY/maxCoord*0.5 + 0.5]
		if not @game
			return
		gl.enable gl.DEPTH_TEST
		@explode e for e in @game.explosions
		@game.explosions = []
		deltaTime = @curTime - @prevTime
		for body, i in @game.bodies when body
			x = @localX body.cx
			y = @localY body.cy
			lvl = Math.min 7, body.level or 0
			switch body.type
				when 'Missile'
					@bodyTrail body, 70 + lvl*7, 14 + lvl*0.3,12, colors.skill.Missiles
				when 'Blast'
					@bodyTrail body, 60 + lvl*5, 4 + lvl*0.3,2, colors.skill.Blaster
				when 'BombBlast'
					@bodyTrail body, 100 + lvl*8, 12,12, colors.skill.BombGun
				when 'FlakBlast'
					@bodyTrail body, 50 + lvl*2, 1,8, colors.skill.Flak
				when 'RayBlast'
					@bodyTrail body, 200 + lvl*12, 6 + lvl*0.4,6, colors.skill.Ray
				when 'Bomb'
					@bodyTrail body, 80 + lvl*5, 24 + lvl*0.5,16, colors.skill.BombGun
				when 'BlackHole'
					charge = (body.time - body.createTime)*0.002
					ang = -Math.max 0, charge - 1
					a = Math.min 1, charge
					r = body.radius*(2.5 - a)
					@xsprites.addPart x,y, r,r, spriteRects.blackHoleCore, 1,1, ang, x,y, colora 0xffffff, a
				when 'WarpEnter', 'WarpExit'
					@addWarp x,y, body.radius, body.type, Math.min 1, (body.time - body.createTime)*0.002
				when 'Hook'
					if body.player and body.player.ship
						sx = @localX body.player.ship.cx
						sy = @localY body.player.ship.cy
						@sprites.line sx, sy, x - sx, y - sy, 10, 6, spriteRects.particle, colors.skill.HookGun
				when 'Asteroid'
					v2 = Math.len2 body.vx, body.vy
					@bodyTrail body, v2 > 10 and 250 or 0, body.radius, body.radius*0.5, 0x10406600, spriteRects.particle, @zsprites
				when 'BonusLife'
					@sprites.add x,y, 30,30, spriteRects.BonusLife
				when 'BonusWeapon'
					c = colors.bonus[skills[body.skill].slot]
					@sprites.add x,y, 30,30, spriteRects.bonus, c&0xffffff80
					@sprites.add x,y, 25,25, spriteRects[body.skill], c
				when 'BonusUpgrade'
					@sprites.add x,y, 30,30, spriteRects.BonusUpgrade
		programs.mesh.use()
		buffers.spaceships.use()
		for body in @game.bodies when body and body.type == 'Ship' and body.player
			x = @localX body.cx
			y = @localY body.cy
			body.tilt or= 0
			tilt = Math.clamp angle(body.ca - body.a)*4, -0.2*Math.PI, 0.2*Math.PI
			body.tilt = Math.lerp body.tilt, tilt, 0.1
			body.tf = Math.euler4 0.1, body.tilt, body.ca - Math.PI*0.5, x, y, -eyeZ, 40
			programs.mesh.setUniforms
				type: ((body.player.info.color0 % colors.hull[0].length)*8 + (body.player.info.color1 % colors.hull[1].length))/64
				view: body.tf
			buffers.spaceships.drawPart body.player.info.ship
			@nameSprites.add x, y - 70, null,20, body.player.nameSprite, 0xffffff80 if @game.player != body.player
			@xsprites.addHorBar x, y - 52, null, 6, spriteRects.lifeBar, Math.lerp 0.04, 0.97, body.life
			@xsprites.addNumberLeft x + 40, y - 68, 32, body.player.level + 1, 0xffcc0080
			if body.player.team?
				@xsprites.add x - 48, y - 52, 8,8, spriteRects.TeamIcon, colora colors.team[body.player.team % colors.team.length], 0.5
			#@xsprites.add x - 45, y - 52, 8,8, spriteRects.TeamIcon, colora colors.team[0], 0.5
			body.engines ?= []
			for engine, i in buffers.spaceships.parts[body.player.info.ship].points
				[ex, ey] = Math.m4v3 body.tf, engine
				e = body.engines[i] ?= {}
				e.cx = coord body.cx + ex
				e.cy = coord body.cy + ey
				sz = 8*engine[3]
				@bodyTrail e, 81, sz,sz, colors.skill.Flak
			if body.emotion?
				if @curTime - body.emotionTime < 2200
					a = Math.smoothpeak 200, 1800, 2200, @curTime - body.emotionTime
					@sprites.add x, y - 100, null, 30, spriteRects[body.emotion], colora 0xffffff, a
				else
					delete body.emotion
			if score = body.player.score
				if score.leaderKill or score.revengeKill or score.multiKill
					if a = 0.7*Math.smoothpeak 100, 4000, 7000, @curTime - body.player.lastKillTime
						body.markAlpha = Math.lerp body.markAlpha or 0, a, 0.1
						sy = y - 110 - (body.emotion and 60 or 0)
						c = colora 0xf01010, body.markAlpha
						@sprites.add x, sy, null,40, spriteRects[score.revengeKill and 'revenge' or 'skull'], c
						if score.leaderKill
							@sprites.add x, sy - 60, 40,20, spriteRects.king, c
						if score.multiKill
							@sprites.addNumberCenter x, sy - 15, 38, score.multiKill + 1, c

		programs.rock.use()
		buffers.rocks.use()
		for body in @game.bodies when body and body.type == 'Asteroid'
			body.ax ?= Math.random() * Math.PI * 2
			body.ay ?= Math.random() * Math.PI * 2
			body.az ?= Math.random() * Math.PI * 2
			body.dax ?= (Math.random() - 0.5) * 0.005
			body.day ?= (Math.random() - 0.5) * 0.005
			body.daz ?= (Math.random() - 0.5) * 0.005
			body.ax = angle body.ax + body.dax*deltaTime
			body.ay = angle body.ay + body.day*deltaTime
			body.az = angle body.az + body.daz*deltaTime
			programs.rock.setUniforms
				view: Math.euler4 body.ax, body.ay, body.az, @localX(body.cx), @localY(body.cy), -eyeZ, body.radius*1.2
			buffers.rocks.drawPart 1

		if @game.player?.ship and not @game.player.ship.deleted
			a0 = Math.PI
			for skill, i in @game.player.skills
				v = skill.cooldown or (if i == 1 and @game.player.ship.energy != 1 then @game.player.ship.energy else 0)
				c = colors.bonus[skills[skill.type].slot]
				@xsprites.addPart 60,0, 10,null, spriteRects.arch, 1,v, a0, 0,0, c&0xffffff80
				a0 += Math.PI

		gl.enable gl.BLEND
		programs.rock.use()
		buffers.rocks.use()
		for body in @game.bodies when body and body.type == 'Ship' and body.shield
			programs.rock.setUniforms
				color: [0.5, 0.5, 3, 0.3*body.shield]
				view: Math.euler4 0.5, 0.5, 0.5, @localX(body.cx), @localY(body.cy), -eyeZ, 64
			buffers.rocks.drawPart 0
		programs.rock.setUniforms {color: [1,1,1,1]}

		for particle, i in @particles
			t = (@curTime - particle.time)/particle.lifetime
			if t >= 0
				if t < 1
					x = coord particle.x + particle.dx*t - @originX
					y = coord particle.y + particle.dy*t - @originY
					hs = Math.lerp particle.size0, particle.size1, t
					(particle.sprites or @sprites).add x,y, hs,hs, particle.sprite or spriteRects.particle, colora particle.color, 1 - t
				else
					@particles[i] = null
		@particles = @particles.filter (particle) -> particle

		if @game.player and @game.player.ship and @game.alive
			@xsprites.add @controls.x, @controls.y, 16,16, spriteRects.circleCrosshair, colors.skill[@game.player?.skills[0].type or 'Shield']
			for skill in @game.player.skills
				if skill.type == 'Ray'
					@sprites.addDirLine @game.player.ship.ca, 260,20, spriteRects.line
					@sprites.addDirLine Math.atan2(@controls.y, @controls.x), 160,4, spriteRects.particle, 0x80000080
				if skill.target
					x = coord skill.target.cx - @originX
					y = coord skill.target.cy - @originY
					if skill.type == 'Force'
						r = skill.target.radius*1.1
						@zsprites.add x,y, r,r, spriteRects.bonus, colors.skill.Force
					else
						@sprites.add x,y, 60,60, spriteRects.target, 0xffffff80
				if skill.hold and not skill.cooldown and not skills[skill.type].cancel? @, skill.target or @game.player.ship
					switch skill.type
						when 'Force'
							body = skill.target ? @game.player.ship
							x = @localX body.cx
							y = @localY body.cy
							s = 20
							r = Math.max(body.radius, 50)*1.1 + s*2
							a = if skill.target then Math.atan2 coord(@originY + @controls.y - body.cy), coord(@originX + @controls.x - body.cx) else body.ca
							@sprites.addPart x + r, y, s,s, spriteRects.dir, 1,1, a, x,y, colors.skill.Force
						when 'BlackHoleGun' then @xsprites.add @controls.x, @controls.y, 60,60, spriteRects.blackHoleCore, 0xffffff80
						when 'WarpGun'
							@addWarp 200*Math.cos(@game.player.ship.ca), 200*Math.sin(@game.player.ship.ca), 40, 'WarpEnter', 0.5
							@addWarp @controls.x, @controls.y, 40, 'WarpExit', 0.5

		gl.depthMask false
		gl.blendFunc gl.SRC_ALPHA, gl.ONE
		programs.sprite.use {tex: textures.sprites, proj: @viewProj}
		buffers.sprite.use()
		@zsprites.draw()
		gl.disable gl.DEPTH_TEST
		@sprites.draw()
		gl.blendFunc gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA
		@xsprites.draw()
		programs.sprite.setUniforms {tex: textures.players}
		@nameSprites.draw()
		@drawUI()
		gl.depthMask true

	emotionButton: (x, y, r, emotion, key) ->
		x = x*@vmin + if x >= 0 then @margin else @w - @margin
		y = y*@vmin + if y >= 0 then @margin else @h - @margin
		r = r*@vmin
		c = 0xffffff80
		@sprites.add x,y, null,r, spriteRects[emotion], c
		@sprites.add x + r, y + r*0.6, r*0.4,r*0.4, spriteRects[key], c

	skillButton: (x, y, r, skill, key) ->
		x = x*@vmin + if x >= 0 then @margin else @w - @margin
		y = y*@vmin + if y >= 0 then @margin else @h - @margin
		r = r*@vmin
		c = 0xffffff80
		@sprites.add x,y, r,r, spriteRects.roundButton, c
		@sprites.add x,y, r,r, spriteRects[skill.type], c
		@sprites.add x + r,	 y + r*0.7, r*0.5,r*0.25, spriteRects.key, c
		@sprites.add x + r*1.1, y + r*0.7, r*0.2,r*0.2, spriteRects[key], c
		v = Math.lerp 0.95, 0.05, 1/8*Math.min skill.level + 1, 8
		@sprites.addBar x + r, y - r*0.3, r*0.5,0, spriteRects.skillLevelBar, v, c

	drawUI: ->
		proj = Math.ortho 0, 0, @w, @h, -1, 1
		lineH = 4*@vmin

		if @showFPS and @stats
			@sprites.addNumberLeft @margin, @margin, lineH, @stats.fps, 0x80ff8080
			@sprites.addNumberLeft @margin, @margin + lineH, lineH, @stats.tps, 0x8080ff80

		if @showUI and @game.player and @game.player.ship
			radarR = 12*@vmin
			radarX = @w - radarR - @margin
			radarY = @h - radarR - @margin

			c = 0xffffff80
			@sprites.add radarX, radarY, radarR,radarR, spriteRects.radar, c
			s = radarR/(1024*3)
			for body, i in @game.bodies when body and body.type == 'Asteroid'
				x = radarX + s*@localX body.cx
				y = radarY + s*@localY body.cy
				r = s*body.radius
				@sprites.add x,y, r,r, spriteRects.particle, 0x808080a0
			for p in @game.radar
				x = radarX + p.x*radarR*0.85
				y = radarY + p.y*radarR*0.85
				c = colors.radar[p.type]
				switch p.type
					when 'Enemy', 'Friend'
						r = radarR*0.09
						@sprites.add x,y, r,r, spriteRects.particle, colora c, 0.4
						r = radarR*0.03
						@sprites.add x,y, r,r, spriteRects.particle, colora c, 0.7
					when 'Leader'
						r = radarR*0.12
						@sprites.add x,y, r,r, spriteRects.particle, colora c, 0.4
						r = radarR*0.08
						@sprites.add x,y, r,r, spriteRects.kingMark, colora c, 0.62
					when 'Revenge'
						r = radarR*0.12
						@sprites.add x,y, r,r, spriteRects.particle, colora c, 0.4
						r = radarR*0.08
						@sprites.add x,y, r,r, spriteRects.skullMark, colora c, 0.62

			@drawScores()

			if @game.alive and @game.player.ship and @game.player.skills
				@skillButton 5, -15, 5, @game.player.skills[0], 'KeyQ'
				@skillButton 15, -5, 5, @game.player.skills[1], 'KeyW'
				x = @w - radarR*1.85 - @margin
				y = @h - lineH
				v = Math.lerp 0.8, 0.05, @game.player.levelProgress
				@sprites.addBar x, radarY, null,radarR, spriteRects.levelBar, v, 0xffffff80
				if @game.alive
					emotionKeys = ['Digit1', 'Digit2', 'Digit3', 'Digit4', 'KeyT', 'KeyR']
					for emotion, i in proto.Emotion.members when emotion != 'JoinTeam' and (emotion != 'LeaveTeam' or @game.player.team?)
						@emotionButton 28 + 7*i, -2.5, 2.5, emotion, emotionKeys[i]

			y = @h - @margin - @game.kills.length*lineH
			y -= 22.5*@vmin if @game.alive
			iconSpacing = Math.round lineH/8
			for pk in @game.kills when a = Math.smoothpeak 200, 5000, 7000, @curTime - pk.time
				x = @margin
				c = colora 0xffffff, a
				if pk.slayer? and pk.slayer != pk.victim
					x += iconSpacing + @nameSprites.addName x,y, null,lineH, pk.slayer.nameIconSprite, c
				x += @sprites.addName x,y, null,lineH, spriteRects[pk.weapon or 'AsteroidCrash'], c
				@nameSprites.addName x,y, null,lineH, pk.victim.nameIconSprite, c
				y += lineH
		if @game.round?.killsToWin and a = Math.smoothpeak 500, 8000, 10000, @curTime - @game.round.startTime
			@sprites.addNumberCenter @w*0.5,@h*0.1, lineH, @game.round.killsToWin, colora 0xff5555, a*0.7
		if winner = @game.round?.winner
			if a = Math.smoothpeak 500, 8000, 10000, @curTime - @game.round.finishTime
				@sprites.add @w*0.5, @h*0.15 - lineH, null,lineH*0.5, spriteRects.king, colora 0xf01010, a*0.7
				@nameSprites.add @w*0.5, @h*0.15, null,lineH*0.5, winner.nameIconSprite, colora 0xffffff, a
		programs.sprite.setUniforms {tex: textures.sprites, proj: proj}
		@sprites.draw()
		programs.sprite.setUniforms {tex: textures.players}
		@nameSprites.draw()

	drawScores: ->
		playerSuccess = (p) -> 100*(p.score?.roundScore or 0) + p.level
		sortedPlayers = @game.players.filter((p) -> p).sort (a, b) -> playerSuccess(b) - playerSuccess(a)
		lineH = 4*@vmin
		tableW = lineH*9
		x = @w - @margin - tableW
		y = @margin
		r = lineH*0.6
		@sprites.add x + r, y + lineH*0.5, r,r, spriteRects.Player, colora 0xffffff, 0.75
		@sprites.addNumberLeft x + r + lineH, y, lineH, sortedPlayers.length, colora 0xffffff, 0.75
		if @game.round.killsToWin
			@sprites.add x + lineH*4, y + lineH*0.5, r,r, spriteRects.skull, colora 0xff5555, 0.8
			@sprites.addNumberLeft x + lineH*4.75, y, lineH, @game.round.killsToWin, colora 0xff5555, 0.8
		y += 6.5*@vmin
		for p, i in sortedPlayers when i < 8 or p == @game.player
			a = p == @game.player and 0.95 or (@showFPS and p.bot and 0.3 or 0.65)
			@nameSprites.addName x,y, null,lineH, p.nameIconSprite, colora 0xffffff, a
			@sprites.addNumberLeft x + lineH*p.nameIconSprite.aspX, y, lineH*0.75, p.level + 1 or 1, colora 0xffcc00, a
			@sprites.addNumberRight x, y + lineH*0.125, lineH*0.75, i + 1, colora 0xffffff, a
			if @game.round.killsToWin
				@sprites.addNumberRight @w - @margin, y, lineH, p.score?.roundScore or 0, colora 0xff5555, a
			y += lineH

	updatePlayersTexture: (players) ->
		lh = Math.round 4*@vmin
		hw = lh*7
		ts = Math.round lh*9/16
		ty = Math.round lh*11/16
		count = 0
		for player in players when player
			count += 1
		if count == 0
			return
		textCanvas = document.createElement 'canvas'
		textCanvas.width = Math.nextPow2 hw
		textCanvas.height = Math.nextPow2 lh*count
		ctx = textCanvas.getContext '2d'
		ctx.globalAlpha = 0.8
		ctx.font = "#{ts}px Arial"
		ctx.fillStyle = 'white'
		ctx.lineWidth = 1
		i = 0
		for player in players when player
			y = i*lh
			i += 1
			[shortName, nameWidth] = fitString ctx, player.info.name, hw - lh
			player.nameIconSprite = spriteRect [0, y, lh + nameWidth, lh], textCanvas.width, textCanvas.height
			player.nameSprite = spriteRect [lh, y, nameWidth, lh], textCanvas.width, textCanvas.height
			ctx.fillText shortName, lh, y + ty
		textures.players.setImage textCanvas
		textures.players.drawTo ->
			i = 0
			for player in players when player
				gl.viewport 0, lh*i, lh, lh
				drawShipModel player.info.ship, player.info.color0, player.info.color1
				i += 1
		programs.mesh.use {proj: @proj}

	addWarp: (x,y, r, color, a) -> @sprites.add x,y, r,r, spriteRects.bonus, colora colors[color], a

if module.hot
	module.hot.dispose ->
		texture.clear() for id, texture of textures
		buffer.clear() for id, buffer of buffers
		program.clear() for id, program of programs



// WEBPACK FOOTER //
// ./client/view.coffee